import { Link } from "react-router-dom";
import DisclaimerImg from "../../../Images/NewUI/disclaimer.png";
import { BANK_STATEMENT } from "../Common/constant";

import { getBank, getLink } from "@Redux/ApplyLoan/action";
import "@Styles/mandate.css";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import ToastMsg from "../../../helper/ToastMsg";
import Heading from "../Common/MainHeading";

 const Sahamati = (props) => {
    const  token  =  props?.user?.User?.token||localStorage.getItem("gpay_token");
    const [bankList, setBankList] = useState([]);
    const [link, setLink] = useState("");
    const [bank, setaBank] = useState("");
    const [bankname, setBankname] = useState("");
    const [setbtnEnable, setBtnEnable] = useState(false);
    
    
  
    useEffect(() => {getBankList(), getSahmatiLink()}, []);
    const getBankList = () => {
      props
        .getBank(token)
        .then((res) => {
          setBankList(res.data);
        })
        .catch((err) => {
          setLoader(false);
          if (err.response?.status === 401) {
           window.location.href = "/";
            localStorage.removeItem("gpay_token");
          }
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
          // console.log(err);
        });
    };
    const getSahmatiLink = () => {
      props
        .getLink(token)
        .then((res) => {
          setLink(res?.data);
        })
        .catch((err) => {
          setLoader(false);
          if (err.response?.status === 401) {
           window.location.href = "/";
            localStorage.removeItem("gpay_token");
          }
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
          // console.log(err);
        });
    };
    const handleChange = (e) => {
      setBankname(e.target.value);
      console.log(bankname, "bankname");
      if (bankname.length > 5){
        setBtnEnable(true)
      }else{
        setBtnEnable(false)
      }
    };
    const reDirectToSahmati = () => {
        window.location.href="/bank_statement_upload";
    };
    return (
    <div className="main_div payme_body">
    <div className="container">
        <div className="pb-4 shadowline">
        <Heading
          headingText={BANK_STATEMENT}
          history={props.history}
        />
        </div>

        <div id="background" className="container">
              <div className="repaymentdisclaimer flex_row ">
                  <img style={{marginRight: 13}} width={16} height={16} src={DisclaimerImg}></img>
                  <p className="selectrepaymentdatedisclaimercolour">Please share the bank account statement of your primary account, where most of your earnings/income/salary is credited, for the last 6 months.</p>
                </div>

                <div className="Sahamatibankdesign">
                <span className='chooseOneLoan m-left'>Select Bank</span>
              
                    
              <form action="#">
                <input className="selectbankinput" value={bankname} onChange={handleChange}>
                </input>
             {/* <select className="sahamatiInputdesign" value={bank} onChange={handleChange}>
               <option value="" disabled>
                 Select Bank
               </option>
               {bankList?.map((item) => {
                 return <option key={item.name}>{item.name}</option>;
               })}
             </select> */}
             
           </form>
                </div>
                   <div className="text-center pt-4">
                       <button
                         disabled={!setbtnEnable}
                         className="btn bg-orange text-white sehamatibtn  px-5 py-3 mb-3"
                         onClick={reDirectToSahmati}
                       >
                         Submit
                       </button>
                      
                     
                     </div>
                    <div className="aligncentre">
                    <Link to="/bank_statement_upload" >
                    <p className="couldntfindbank">Couldn't find your bank ?</p>
                    </Link>
                    <p className="couldntfindbankpara">E-statement verification may <br/> not be available for your bank</p>
                    </div>
        </div>
       

        
    </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    userDetail: state.userDetail,
  };
};
export default connect(mapStateToProps, {
  getBank,
  getLink,
})(Sahamati);












